import { TL4K_ALL_CAPS_CSS } from '../utils/allCapsStyles';

/**
 * Regole del maiuscolo globale, da montare accanto al contenitore che riceve
 * `TL4K_ALL_CAPS_CLASS` (solo col maiuscolo attivo). `<style>` semplice, senza
 * `href`/`precedence`: alcune app (scratch-jr-web) sono ancora su React 18.
 */
export function AllCapsStyles() {
  return <style data-tl4k-all-caps-styles="">{TL4K_ALL_CAPS_CSS}</style>;
}
